<section class="article-component-cont">
  <header>
    <h3 class="ent-color"><i class="fas fa-user" aria-hidden="true"></i>Client information</h3>
  </header>
  <div class="article-content client-info">
    <!-- client information table -->
    <ng-content></ng-content>
  </div>
</section>
